import moment from 'moment';
import { post } from '../networking/Api';
import Constent from '../networking/Constent';

const helpers = {
    getCurrentDateTime: function(){
      var date = new Date().getDate(); //Current Date
      var month = new Date().getMonth() + 1; //Current Month
      var year = new Date().getFullYear(); //Current Year
      var hours = new Date().getHours(); //Current Hours
      var min = new Date().getMinutes(); //Current Minutes
      if(month<=9){ month=""+0+month }
      if(date<=9) { date=""+0+date   }
      if(hours<=9){ hours=""+0+hours }
      if(min<=9)  { min=""+0+min     }
      var timeStamp= year+"-"+month+"-"+date+" "+hours+":"+min;
      return timeStamp;
    },
    getCurrentDate: function(){
      return new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().split("T")[0];
      /* return YYYY-mm-dd  => Today date */
    },
    getCurrentCustomDate: function(){
      var date = new Date().getDate(); //Current Date
      var month = new Date().getMonth() + 1; //Current Month
      var year = new Date().getFullYear(); //Current Year
      var hours = new Date().getHours(); //Current Hours
      var min = new Date().getMinutes(); //Current Minutes
      if(month<=9){ month=""+0+month }
      if(date<=9) { date=""+0+date   }
      if(hours<=9){ hours=""+0+hours }
      if(min<=9)  { min=""+0+min     }
      var timeStamp= date+"/"+month+"/"+year;
      return timeStamp;
    },
    lastTimestampDetail: function(userId){
      try {
        var timeStamp = helpers.getCurrentDateTime();    
        var formData=new FormData();
        formData.append("user_id",userId);
        formData.append("timeStamp",timeStamp);
        post(Constent.LASTTIMESTAMPDETAIL,formData).then(response=>{
            if(response.status===true){
              localStorage.setItem('checkin_projectid',"0"); 
              localStorage.setItem('checkin_projectname',''); 
              localStorage.setItem('meetDateTime',""); 
                var status_code = response.status_code;
                if(status_code === 1){
                  localStorage.setItem('diff',""); 
                  localStorage.setItem("checkInStatus",true);
                }else{
                  // already checkin
                  var meet = response.data.meet_time;

                  var momentCurrentTime =  moment(timeStamp,"YYYY-MM-DD HH:mm:ss");
                  var momentMeetTime =  moment(meet,"YYYY-MM-DD HH:mm:ss");
                  var ruleMeetTime = "";
                  var diff = '00:00';   
                  if(momentMeetTime > momentCurrentTime){
                     ruleMeetTime =  moment(meet,"YYYY-MM-DD HH:mm:ss").format("HH:mm");
                     diff = '00:00';     
                  }else{
                    ruleMeetTime = "";
                    diff = moment.utc(moment(timeStamp,"YYYY-MM-DD HH:mm:ss").diff(moment(meet,"YYYY-MM-DD HH:mm:ss"))).format("HH:mm") 
                  }
                  localStorage.setItem('diff',diff);
                  localStorage.setItem('ruleMeetTime',ruleMeetTime);  

                  var momentCustomMeetDateTime = moment(meet,"YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY - HH:mm");
                  localStorage.setItem("meetDateTime",momentCustomMeetDateTime);

                  if(response.data.project_id !== 0){
                    localStorage.setItem("status","project");
                  }else if(response.shift_id !== 0){
                    localStorage.setItem("status","shift_id");
                  }else{
                    localStorage.setItem("status","time");
                  }
                  localStorage.setItem('checkInStatus',false); 
                  
                  if(response.project_id !== 0){
                    localStorage.setItem('checkin_projectid',response.project_id); 
                    localStorage.setItem('checkin_projectname',response.project_name); 
                  }
                }
            }else{
              localStorage.setItem("status","");
              localStorage.setItem('checkInStatus',true); 
            }
        })
      } catch(e) {
        console.log(e);
      }  
    },
    isIntegrationExpired: function(integrationID){
     let output = 0;
     let menu_permission= localStorage.getItem('menu_permission');
     var menulist=JSON.parse(menu_permission);
     menulist.map(item => {
        if(item.integration_id===integrationID){
            if(item.is_expired===true){
              output = 1;
            }
          }
          // return console.log('1');
        });
     return output;
    },
    isEmpty: function(obj) {
        for(var key in obj) {
            if(obj.hasOwnProperty(key))
                return false;
        }
        return true;
    },
    tasktype: function(param1){
       switch (param1) {
              case 1:
                return 'Feature';
              case 2:
                return 'Support';
              case 3:
                return 'Task';
              case 4:
                return 'Activity';
              case 5:
                return 'Output';
              case 6:
                return 'Bug';
              default:
                return 'Task';
            } 
    },
    taskStatus: function(param1){
       switch (param1) {
          case 1:
            return 'New';
          case 2:
            return 'In process';
          case 3:
            return 'Testing';
          case 4:
            return 'Resolved';
          case 5:
            return 'On Hold';
         default:
            return 'New';
        }
        
    },
    taskPrority: function(param1){
       switch (param1) {
          case 1:
            return 'Low';
          case 2:
            return 'Normal';
          case 3:
            return 'High';
          case 4:
            return 'Urgent';
          case 5:
            return 'Immidiate';
          default:
            return 'Low';  
        }
    },
    taskPercent :function(param1){
       switch (param1) {
          case 0:
            return '0';
          case 10:
            return '10';
          case 20:
            return '20';
          case 30:
            return '30';
          case 40:
            return '40';
          case 50:
            return '50';
          case 60:
            return '60';
          case 70:
            return '70';
          case 80:
            return '80';
          case 90:
            return '90';
          case 100:
            return '100';
          default:
            return '0';    
        }
    },
    percentList:function(){
      const list = [
        { value: '0', label: '0'},
        { value: '10', label: '10'},
        { value: '20', label: '20'},
        { value: '30', label: '30'},
        { value: '40', label: '40'},
        { value: '50', label: '50'},
        { value: '60', label: '60'},
        { value: '70', label: '70'},
        { value: '80', label: '80'},
        { value: '90', label: '90'},
        { value: '100', label: '100'}
      ];
      return list;

    },
    taskStatusList:function(){
      const taskstatus = [
        { value: '1', label: 'New'},
        { value: '2', label: 'In process'},
        { value: '3', label: 'Testing'},
        { value: '4', label: 'Resolved'},
        { value: '5', label: 'On Hold'}
      ];
      return taskstatus;
    },
     taskPriorityList:function(){
      const taskstatus = [
        { value: '1', label: 'Low'},
        { value: '2', label: 'Normal'},
        { value: '3', label: 'High'},
        { value: '4', label: 'Urgent'},
        { value: '5', label: 'Immidiate'} 
      ];
      return taskstatus;
    },
    taskTypeList:function(){
      const taskstatus = [
        { value: '1', label: 'Feature'},
        { value: '2', label: 'Support'},
        { value: '3', label: 'Task'},
        { value: '4', label: 'Activity'},
        { value: '5', label: 'Output'},
        { value: '6', label:'Bug'}     
      ];
      return taskstatus;
    },
    isIntegrationGuestWriteAccess: function(integrationID){
       let output = 0;
       let menu_permission= localStorage.getItem('menu_permission');
       var menulist=JSON.parse(menu_permission);
       menulist.map(item => {
          if(item.integration_id === integrationID){
              if(item.guest_write_access===1){
                output = 1;
              }
            }
             return console.log('1');
          });
       return output;
      },     
}

export default helpers;